"use client";
import React from "react";

// 출처 사이트 링크. 대부분 일반 GET(<a>)이지만, 사회적기업포털(seis.or.kr) 상세는
//   POST 전용(GET 은 목록 페이지로 빠짐)이라 subPage.do?...&tabId=view URL 을 감지해
//   POST 폼(새 탭)으로 연다. 서버가 CSRF 토큰을 검증하지 않아 파라미터만으로 열림.
export default function SourceLink({ href, style, children }: { href: string; style?: React.CSSProperties; children: React.ReactNode }) {
  // URL 없는 출처(예: 구 board 폐기로 detail_url 없는 글) — 링크 없이 기관명만 표시(클릭 불가).
  if (!href) return <div style={{ ...style, cursor: "default" }}>{children}</div>;
  let post: { action: string; fields: Record<string, string> } | null = null;
  try {
    const u = new URL(href);
    if (/(^|\.)seis\.or\.kr$/.test(u.hostname) && u.pathname.endsWith("/subPage.do") && u.searchParams.get("tabId") === "view") {
      const fields: Record<string, string> = {};
      for (const k of ["tabId", "pbancGbCd", "itgrdAplyPbancSn"]) {
        const v = u.searchParams.get(k);
        if (v) fields[k] = v;
      }
      post = { action: `${u.origin}${u.pathname}?menuId=${u.searchParams.get("menuId") ?? "30400"}`, fields };
    }
  } catch {
    /* 잘못된 URL → 일반 링크로 폴백 */
  }

  if (post) {
    return (
      <form action={post.action} method="POST" target="_blank" style={{ margin: 0 }}>
        {Object.entries(post.fields).map(([k, v]) => (
          <input key={k} type="hidden" name={k} value={v} />
        ))}
        <button type="submit" style={{ ...style, width: "100%", border: "none", cursor: "pointer", font: "inherit" }}>
          {children}
        </button>
      </form>
    );
  }
  return (
    <a href={href} target="_blank" rel="noreferrer" style={style}>
      {children}
    </a>
  );
}
